import React from 'react';

import { useSelector } from 'react-redux';

import { ComponentId } from '@/models/channelModels';
import { useAppSelector } from '@/redux/hooks';
import { getCapabilities } from '@/util/capabilities';

export default function useFeatureGate() {
  const channel = useSelector((state: any) => state.auth.channel);
  const companyData = useAppSelector((state) => state.auth.companyAccount);

  const caps = React.useMemo(() => getCapabilities(channel, companyData), [channel, companyData]);

  const allowComponent = React.useCallback((id: ComponentId) => caps.allowedComponents.has(id), [caps]);

  return { channel, allowComponent, caps };
}
